import React, { Component } from 'react';
import moment from 'moment';
import RavenUtil from '../common/ravenUtil';
import ProgressSpinnerSmall from 'APP_ROOT/components/common/ProgressSpinnerSmall';
import LambdaUtil from '../aws/lambda/lambdaUtil';
import { strings } from '../../localization';
import LiveFeed from '../pages/dashboard/liveFeed';
import { Creatable } from 'react-select';

const CUSTOM_MESSAGE_MAX_CHARACTERS = 15;
const SEND_MESSAGE_SUCCESS_AUTOCLEAR_TIMEOUT = 3000;
const SEND_MESSAGE_STATUS_ENUM = {
    READY: "READY",
    SENDING: "SENDING",
    SUCCESS: "SUCCESS",
    FAIL: "FAIL"
};
const KeyCode = { // the same as FaceDetailsModal.KeyCode
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
};

export default class VehiclePopup extends Component {


    constructor(props) {

        super(props);

        this.sendMessageSuccessAutoClearTimeout = null;

        this.state = {
            activeDTCsPanelIsVisible: false,
            sendText: "",
            sendTextCreatableValue: null,
            sendTextStatus: SEND_MESSAGE_STATUS_ENUM.READY,
            sendTextIsBlank: false // if user submits an empty string, set to true and render "Cancelling..." for the placeholder
        };

    }

    // Store the end options in the class so that they
    // persist beyond this particular popup
    static sendOptions = [
        { value: 'call', label: strings.vehicle_popup_message_option_call_office },
        { value: 'stop', label: strings.vehicle_popup_message_option_stop_driving_now },
        { value: 'return', label: strings.vehicle_popup_message_option_return_to_office },
    ];

    componentWillUnmount() {
        if (this.sendMessageSuccessAutoClearTimeout) {
            clearTimeout(this.sendMessageSuccessAutoClearTimeout);
        }
    }

    onMessageFieldFocus = (event) => {
        this.props.onMessageBoxFocus();
    }

    onMessageFieldBlur = (event) => { // the same as FaceDetailsModal.onNameFieldBlur
        const value = event.target.value;
        if (value) {
            this.setState({
                sendText: value
            });
        }
        if(!event.relatedTarget || !event.relatedTarget.form) {
            this.form.focus();
        }
        this.props.onMessageBoxBlur();
    }

    onKeyDownInSelect = (event) => { // very similar to FaceDetailsModal.onKeyDownInSelect
        switch (event.keyCode) {
            case KeyCode.ENTER:
                event.preventDefault();
                this.dispatchMessage();
                break;
            default:
                break;
        }
    }

    shouldKeyDownEventInSelectCreateNewOption = (event) => {
        switch (event.keyCode) {
            case KeyCode.TAB:
                return true;
            case KeyCode.ENTER:
                return true;
            default:
                return false;
        }
    }

    onSendChange = (x) => {

        if (!x) {
            // clearing label?, i.e. user tapped the x icon?
            this.setState({
                sendText: null,
                sendTextCreatableValue: x
            });
            return;
        }

        if (!x.label) {
            console.log("vehiclePopup onSendChange x.label is undefined. Halting.");
            return;
        }

        let truncatedAndTrimmedLabel = x.label;

        // check for custom messages and truncate as needed
        // a custom message has the same value and label
        if (x.label === x.value) { //{value: "This is a test", label: "This is a test", className: "Select-create-option-placeholder"} */

            // Important: It is ok to send an empty string! (it clears the currently dispatched message on raven, if present)
            truncatedAndTrimmedLabel = truncatedAndTrimmedLabel.trim(); // trim leading and trailing white space before truncating.
            truncatedAndTrimmedLabel = truncatedAndTrimmedLabel.substring(0, CUSTOM_MESSAGE_MAX_CHARACTERS);
            truncatedAndTrimmedLabel = truncatedAndTrimmedLabel.trim(); // truncating may have introduced white space that should be trimmed (again)

            // enforce the CUSTOM_MESSAGE_MAX_CHARACTERS when adding the option to Creatable.
            x.label = truncatedAndTrimmedLabel;
            x.value = truncatedAndTrimmedLabel;
        }

        this.setState({
            sendText: truncatedAndTrimmedLabel,
            sendTextCreatableValue: x});
    }

    onDispatchSuccess = () => {
        // console.log("vehiclePopup onDispatchSuccess");
        this.setState({
            sendTextStatus: SEND_MESSAGE_STATUS_ENUM.SUCCESS
        });

        this.sendMessageSuccessAutoClearTimeout = setTimeout(() => {
            this.dismissDispatchSuccess()
        }, SEND_MESSAGE_SUCCESS_AUTOCLEAR_TIMEOUT);
    }

    onDispatchFail = (err) => {
        // console.log("vehiclePopup onDispatchFail error", err);
        this.setState({
            sendTextStatus: SEND_MESSAGE_STATUS_ENUM.FAIL
        });
    }

    targetRavenUuid = () => {
        return this.props.showcaseTargetRavenUuid || this.props.raven.ravenUuid;
    }

    dispatchMessage = () => {
        let sendTextIsBlank = false;
        let sendText = this.state.sendText;
        if ((!sendText) || (sendText === "")) { // assumption: sendText strings have been trimmed and truncated already in onSendChange
            sendText = null;
            sendTextIsBlank = true;
        } else if (!this.state.sendTextCreatableValue) {
            // if the user clicks the send button without pressing enter or tab, Creatable will not add the new item automatically
            const newOption = {value:sendText, label:sendText};
            this.addMessageOptionIfNotInList(newOption);
            this.setState({sendTextCreatableValue: newOption});
        }

        let payload = {
          ravenUuids: [ this.targetRavenUuid() ],
          message: sendText,
        };

        console.log(`dispatchMessage(${payload.ravenUuids}): ${this.state.sendText}`);

        //document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: "Sending " + this.state.sendText.label, override: true } }));
        // FIXME - grab the stage a better way
        LambdaUtil.dispatchMessage(this.props.stage, payload, this.onDispatchSuccess, this.onDispatchFail);

        this.setState({
            sendTextStatus: SEND_MESSAGE_STATUS_ENUM.SENDING,
            sendTextIsBlank: sendTextIsBlank
        });
    }

    addMessageOptionIfNotInList = option => {
        console.log("addMessageOptionIfNotInList", option);
        if(!VehiclePopup.sendOptions.some(item => item.label === option.label)){
            VehiclePopup.sendOptions.unshift(option);
        }
    }

/*
                    if (targetRaven.reverseGeocodeFeatures && !targetRaven.noServicePlan) {
                        var address = targetRaven.reverseGeocodeFeatures.find(feature => {
                            return feature.place_type.indexOf('address') >= 0;
                        })
                        var place = targetRaven.reverseGeocodeFeatures.find(feature => {
                            return feature.place_type.indexOf('place') >= 0;
                        })
                        locationLabel = address.address + " " + address.text + " " + place.text;
                        if (targetRaven.dashboard.type !== "PARKED") locationLabel = address.text + " " + place.text
                    }
*/
    toggleDisplayDTCs = () => {
        var newState = !this.state.activeDTCsPanelIsVisible;
        if(newState)
        {
            this.props.onDTCsFocus();
        }
        else
        {
            this.props.onDTCsBlur();
        }

        this.setState({
            activeDTCsPanelIsVisible: newState
        });
    }

    dismissDispatchSuccess = () => {
        if (this.state.sendTextStatus !== SEND_MESSAGE_STATUS_ENUM.SUCCESS) {
            console.log("vehiclePopup dismissDispatchSuccess since status has changed from SUCCESS to " + this.state.sendTextStatus);
            return;
        }
        this.setState({
            sendTextStatus: SEND_MESSAGE_STATUS_ENUM.READY, // for now, just reset state to 'ready'
            sendTextCreatableValue: null,
            sendTextIsBlank: false
        });
    }

    dismissSendMessageContainerError = () => {
        this.setState({
            sendTextStatus: SEND_MESSAGE_STATUS_ENUM.READY, // for now, just reset state to 'ready'
            sendTextIsBlank: false
        });
    }

    promptTextCreator = (label) => {

        return  strings.formatString(strings.vehicle_popup_message_custom_x_of_x_colon_x, label.length, CUSTOM_MESSAGE_MAX_CHARACTERS, label.substring(0, CUSTOM_MESSAGE_MAX_CHARACTERS));
    }

    render()
    {

        if(this.props.features.vehicle_popup === "old")
        {
            return this.renderOldPopup();
        }

        var activeDTCs = this.props.raven.vehicle.activeDTCs;
        //console.log("typeof activeDTCs: ", typeof activeDTCs)

        var preview1 = this.props.features.media_view && this.props.raven.canViewMedia ? RavenUtil.getPreviewImageHTML(this.props.raven, 0, 180, 135) : null;
        //var preview2 = RavenUtil.getPreviewImageHTML(this.props.raven, 1, 180, 135);

        var fuelClass = "fuel-bar green";
        if(this.props.raven.vehicleState.currentFuel < 25)
        {
            fuelClass = "fuel-bar red";
        }

        var fuelClasses = [];
        var fuelLimit = 0;

        for(var i = 0; i < 8; i++)
        {
            if(this.props.raven.vehicleState.currentFuel > fuelLimit)
            {
                fuelClasses.push(fuelClass);
            }
            else
            {
                fuelClasses.push("fuel-bar");
            }
            fuelLimit += 100 / 8;
        }

        var units = (this.props.unitOfMeasure === "METRIC");

        var currentSpeed = this.props.raven.vehicleState.currentSpeed && isFinite(this.props.raven.vehicleState.currentSpeed) ? this.props.raven.vehicleState.currentSpeed.toString() : '0';

        var speedValueString = Math.floor(RavenUtil.convertDistance(currentSpeed, this.props.unitOfMeasure));
        var speedUnitsString = (units ? ' kph' : ' mph');

        let sendMessageButtonForStatus;
        let sendMessageOverlayForStatus;
        let creatablePlaceholder = strings.vehicle_popup_message_select_or_type;
        if (this.state.sendTextIsBlank === true) {
            creatablePlaceholder = strings.vehicle_popup_message_canceling;
        }
        switch (this.state.sendTextStatus) {
            case SEND_MESSAGE_STATUS_ENUM.READY:
                sendMessageButtonForStatus = <button className="btn send-message" onClick={this.dispatchMessage}></button>;
                sendMessageOverlayForStatus = null;
                break;
            case SEND_MESSAGE_STATUS_ENUM.SENDING:
                sendMessageButtonForStatus = <ProgressSpinnerSmall />
                sendMessageOverlayForStatus = null;
                break;
            case SEND_MESSAGE_STATUS_ENUM.SUCCESS:
                //TODO createa a timeout to clear back to SEND_MESSAGE_STATUS_ENUM.READY
                sendMessageButtonForStatus = <button className="btn send-message-success"></button>;
                sendMessageOverlayForStatus = null;
                break;
            case SEND_MESSAGE_STATUS_ENUM.FAIL:
                //TODO createa a timeout to clear back to SEND_MESSAGE_STATUS_ENUM.READY
                sendMessageButtonForStatus = null;
                sendMessageOverlayForStatus = <div className="send-message-container-overlay error" onClick={this.dismissSendMessageContainerError}><i className="material-icons">error_outline</i> {strings.vehicle_popup_message_send_error}<button className="btn close-overlay">X</button></div>
                break;
            default:
                sendMessageButtonForStatus = null;
                sendMessageOverlayForStatus = null;
                console.log("vehiclePopup render for invalid this.state.sendTextStatus:", this.state.sendTextStatus);
        }

        var facialRecognitionEnabled = this.props.features && this.props.features.facial_recognition;

        if (this.props.raven.isDriving === false) {
            facialRecognitionEnabled = false; // effectively, do not show unknown_driver/no_driver_detected for parked cards
        }

        var driverName = "";
        if (facialRecognitionEnabled) {
            if (this.props.raven.vehicle && this.props.raven.vehicle.currentDriver) {
                if (this.props.raven.vehicle.currentDriver.name) {
                    driverName = this.props.raven.vehicle.currentDriver.name;
                } else {
                    driverName = strings.unknown_driver;
                }
            } else {
                driverName = strings.no_driver_detected;
            }
        }

        return (
            <div className="vehicle-details"
                onMouseEnter={this.props.onMouseEnter}
                onMouseLeave={this.props.onMouseLeave}
            >
                <header>
                    <span className="vehicle-name">{this.props.raven.vehicle.name}</span>
                    <span className="driver-name">{driverName}</span>
                    <div style={{
                        clear: "both", /* all we want is a new line */
                        height: "0px", /* reset */
                        width: "0px", /* reset */
                        margin: "0px", /* reset */
                        padding: "0px" /* reset */}}></div>
                    <span className="vehicle-make-model-year"></span>
                    <span className="vehicle-status">{strings.vehicle_popup_status_label} {this.props.raven.isDriving ? strings.raven_status_label_TRIP : strings.raven_status_label_PARKED}</span>
                </header>
                <section className="sitrep">
                    <div className="raven-preview-container">
                        {
                            this.state.activeDTCsPanelIsVisible ? this.renderDTCs(activeDTCs ) : null
                        }
                        { this.props.features.media_view && this.props.raven.canViewMedia ?  <LiveFeed {...this.props } /> : null }
                    </div>

                    <div className="sitrep-module-container">
                        <div className="sitrep-module-value">{speedValueString}</div>
                        <div className="sitrep-module-label">{speedUnitsString}</div>
                    </div>

                    <div className="sitrep-module-container fuel">
                        <div className="sitrep-module-value fuel">
                            <span className={fuelClasses[0]}></span>
                            <span className={fuelClasses[1]}></span>
                            <span className={fuelClasses[2]}></span>
                            <span className={fuelClasses[3]}></span>
                            <span className={fuelClasses[4]}></span>
                            <span className={fuelClasses[5]}></span>
                            <span className={fuelClasses[6]}></span>
                            <span className={fuelClasses[7]}></span>
                        </div>
                        <div className="sitrep-module-label">
                            {strings.vehicle_fuel}
                        </div>
                    </div>
                    { (activeDTCs.length > 0) ?
                        <div onClick={this.toggleDisplayDTCs} className="sitrep-module-container red"> { /* add " red" to class if problems greater than 0 */ }
                            <div className="sitrep-module-value">
                                { activeDTCs.length }
                            </div>
                            <div className="sitrep-module-label">
                                { (activeDTCs.length > 1) ? strings.vehicle_problems : strings.vehicle_problem }
                            </div>
                        </div>
                        :
                        <div className="sitrep-module-container">
                            <div className="sitrep-module-value">
                                0
                            </div>
                            <div className="sitrep-module-label">
                                {strings.vehicle_problems}
                            </div>
                        </div>

                    }
                    { preview1 ?  <div className="raven-last-update">{preview1.timestamp}</div> : null }

                </section>
                {this.props.canDispatchMessage ?
                    <form onSubmit={this.dispatchMessage} ref={(form) => {this.form = form;}}>
                        <div className="send-message-container">
                            <div className="send-message-container-popup-area-extender"></div>
                            <label className="send-message-label">{strings.vehicle_popup_message_label}</label>
                            <Creatable id="send-message-select"
                                options={VehiclePopup.sendOptions}
                                name="send-select"
                                inputProps={{ maxLength: CUSTOM_MESSAGE_MAX_CHARACTERS, autoComplete: "off"}}
                                value={this.state.sendTextCreatableValue}
                                onChange={this.onSendChange}
                                onBlur={this.onMessageFieldBlur}
                                onFocus={this.onMessageFieldFocus}
                                onInputKeyDown={this.onKeyDownInSelect}
                                shouldKeyDownEventCreateNewOption={this.shouldKeyDownEventInSelectCreateNewOption}
                                onBlurResetsInput={false}
                                onCloseResetsInput={false}
                                clearable={true}
                                placeholder={creatablePlaceholder}
                                promptTextCreator={this.promptTextCreator}
                                />

                            {sendMessageButtonForStatus}
                            {sendMessageOverlayForStatus}
                        </div>
                    </form>
                : 
                    null
                }   
            </div>

        );

    }

    renderDTCs(activeDTCs) {

        var dtcs = activeDTCs.map((dtc, index) => {

            var possibleCauses = dtc.possibleCauses.map( (cause, index) => { return <li key={index} >{cause}</li> });

            var severityLabel = strings.dtc_severity_unknown;
            var severityIconSRC = "/images/icon-dtc-medium-severity.png";
            var ios8601date =  typeof dtc.ts === 'string' && dtc.ts.endsWith('Z') ? dtc.ts : dtc.ts + "Z";
            switch (dtc.severity) {
                case "SEVERITY_HIGH":
                    severityLabel = strings.dtc_severity_high;
                    severityIconSRC = "/images/icon-dtc-high-severity.png";
                    break
                case "SEVERITY_MEDIUM":
                    severityLabel = strings.dtc_severity_medium;
                    severityIconSRC = "/images/icon-dtc-medium-severity.png";
                    break
                case "SEVERITY_LOW":
                    severityLabel = strings.dtc_severity_low;
                    severityIconSRC = "/images/icon-dtc-low-severity.png";
                    break
                default:
                    // defaults already set before switch
                    break
            }
            return (
                <div key={index}>
                    <header>
                        <img src={severityIconSRC} alt="alert" className="icon-severity"></img>
                        <span className="dtc-code">{dtc.code}</span> <span className="dtc-severity">{severityLabel}</span>
                    </header>
                    <div className="dtc-time">
                        {moment(ios8601date).format('MMMM Do[,] h:mm a') }
                    </div>
                    <h1 className="dtc-title">{dtc.title}</h1>
                    { possibleCauses.length > 0 ?
                        <div>
                            <h3 className="dtc-causes-heading">{strings.vehicle_problem_possible_causes_title}</h3>
                            <ul className="dtc-causes">
                                {possibleCauses}
                            </ul>
                        </div> :
                        null
                    }
                </div>
            );
        });

        return (
            <div className="vehicle-problems-details-overlay">
                <div className="close-overlay-button-row"><button className="btn close-overlay" onClick={this.toggleDisplayDTCs}>X</button></div>
                <div className="scrollable-details-wrapper">
                    {dtcs}
                </div>
            </div>

        );
    }

    renderOldPopup() {

        var targetRaven = this.props.raven;
        try {
            var locationLabel = null
            if (targetRaven.reverseGeocodeFeatures && !targetRaven.noServicePlan) {
                var address = targetRaven.reverseGeocodeFeatures.find(feature => {
                    return feature.place_type.indexOf('address') >= 0;
                });
                // Added some null checks
                if(!address) address = { address: "", text: ""};
                if(!address.address) address.address = "";
                var place = targetRaven.reverseGeocodeFeatures.find(feature => {
                    return feature.place_type.indexOf('place') >= 0;
                })
                locationLabel = address.address + " " + address.text + (place ? " " + place.text : "");
                if (targetRaven.isDriving) locationLabel = address.text + (place ? " " + place.text : "");
            }
            return (
                <div>
                    <h5>{targetRaven.vehicle.name}</h5>
                    <p>{this.props.raven.isDriving ? strings.raven_status_label_TRIP : strings.raven_status_label_PARKED}</p>
                    <p className="gray">{locationLabel}</p>
                </div>
            );
        } catch (e) {
            return null;
        }

    }
}
